module.exports = __webpack_public_path__ + "media/images/icons/vendors/bartender-84dee90a2d16f72163f0a523538c2cac.png";